<template>
  <div class="store-bind">
    <div class="section-right-content-box">
      <div class="friend">多店铺绑定</div>
      <div class="head-box">
         <img

          src="@/assets/images/new_icon_reminder.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 3px 8px 0 0;
          "
        />
        <div class="head-content">
          <span class="block">1. 被绑定店铺必须订购云短信服务。</span>
          <span class="block">2. 授权成功后，子店铺和主店铺、子店铺之间均可切换登录。</span>
          <span class="block">3. 绑定成功后，需要重新登录主店铺才能生效。</span>
          <span class="block">
            4.
            <span style="color: #FF5F3E;">【重要提示】</span>
           根据京东要求，超过7天未登录软件将停止订单数据推送，会导致订单中心不能正常发送催付物流短信，数据查询出现误差等问题，为确保功能正常使用，请务必每个店铺每周至少登录1次软件(多店铺绑定确保主店铺每周登录1次)。
          </span>
        </div>
      </div>
      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">当前店铺</span>
      </div>
      <div class="store-box">
        <span class="span" style="margin-left: 25px; font-size: 14px"
          >当前店铺：{{ shopName }}</span
        >
      </div>
      <div class="binding-box" v-if="this.hostOrSonFlag != 2">
        <div class="binding-content" v-if="this.hostOrSonFlag == 0">
          <span>授权给：</span>
          <div class="content-right">
            <el-input
              size="small"
              class="input"
              v-model="wangwangNum"
            ></el-input>
            <el-button
              type="primary"
              size="small"
              class="button"
              v-zoom='{from:pageName,name:"申请绑定"}'
              @click="handleBind"
              >申请绑定</el-button
            >&nbsp;&nbsp;(注：只能授权给订购云短信的店铺，发起授权当前店铺为子店铺)
          </div>
          <span class="tips" v-if="!phoneBinded">
            您还未绑定手机号，无法发起申请，点击
            <span class="tips-text" :style="{ color: changeColor }"
              >绑定手机号</span
            >
          </span>
        </div>
        <div
          class="binding-content"
          v-else-if="this.hostOrSonFlag == 1 && this.statuse == 1"
        >
          <span>授权给：</span>
          <div class="content-right">
            <!-- <el-input
              size="small"
              placeholder="请输入旺旺号"
              class="input"
              v-model="wangwangNum"
              :disabled="true"
            ></el-input> -->
            <span class="Application">
              <i class="iconfont icontijiaochenggong"></i>
              <span>{{hostshop}}</span>
            </span>
            <el-button
              type="primary"
              size="small"
              class="button"
              v-zoom='{from:pageName,name:"取消绑定"}'
              @click="updateBindingStatushandOne(2, sellerShopBindingId)"
              >取消绑定</el-button
            >
          </div>
          <span class="tips" v-if="!phoneBinded">
            您还未绑定手机号，无法发起申请，点击
            <span class="tips-text" :style="{ color: changeColor }"
              >绑定手机号</span
            >
          </span>
        </div>
        <div
          class="binding-content"
          v-else-if="this.hostOrSonFlag == 1 && this.statuse == 0"
        >
          <span>绑定店铺：</span>
          <span>{{ hostshop }}</span
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div class="content-right">
            <el-button
              type="primary"
              size="small"
              class="button"
              v-zoom='{from:pageName,name:"取消申请"}'
              @click="updateBindingStatushand(2, sellerShopBindingId)"
              >{{ bindStatus == 0 ? "取消申请" : "取消申请" }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="state_tabel" v-else>
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">绑定记录</span>
        </div>
        <el-table
          v-loading="talbeLoading"
          ref="multipleTable"
          :data="tableList"
          tooltip-effect="light"
          style="width: 100%; border: 1px solid #eaeaea"
        >
          <el-table-column label="申请店铺" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.claimer }}</template>
          </el-table-column>
          <el-table-column label="申请时间" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="hoveTitle">{{ scope.row.sendtime }}</div>
            </template>
          </el-table-column>
          <el-table-column label="当前状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="hoveTitle">
                {{ scope.row.status == 0 ? "等待审核" : "审核完成" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" class="special">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0">
                <el-button
                  @click="updateBindingaccess(1, scope.row.id)"
                  class="b1"
                  size="mini"
                  v-zoom='{from:pageName,name:"同意"}'
                  style="margin-right: 10px"
                  >同意</el-button
                >
                <el-button
                  @click="updateBindingStatushand(2, scope.row.id)"
                  class="b2"
                  size="mini"
                  v-zoom='{from:pageName,name:"拒绝"}'
                  >拒绝</el-button
                >
              </div>
              <div v-else>
                <el-button
                class="b2"
                  size="mini"
                  v-zoom='{from:pageName,name:"取消绑定"}'
                  @click="updateBindingStatushandOne(2, scope.row.id)"
                  >取消绑定</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="step-box">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">操作教程</span>
        </div>
        <div class="step-detail-box">
          <div class="step-tips">
            <span :style="{ color: changeColor }">绑定流程</span>
            <img src="../../assets/images/nextN.png" class="icon" />
          </div>
          <div class="step-card-box">
            <el-card class="box-card card-one">
              <span>授权给:</span>
              <div
                :style="{ border: '1px solid ' + changeColor }"
                class="button"
              >
                <span :style="{ color: changeColor }">店铺(主)</span>
              </div>
              <div :style="{ background: changeColor }" class="button">
                <span :style="{ color: '#fff' }">发出申请</span>
              </div>
            </el-card>

            <img src="../../assets/images/next.png" class="next-icon" />

            <el-card class="box-card card-two">
              <el-table
                :data="demoData"
                tooltip-effect="light"
                :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
                style="width: 100%"
              >
                <el-table-column
                  property="store"
                  label="申请绑定店铺"
                  width="120"
                ></el-table-column>
                <el-table-column
                  property="state"
                  label="状态"
                  width="100"
                ></el-table-column>
                <el-table-column
                  property="num"
                  label="计费总条数"
                  width="100"
                ></el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      style="width: 60px"
                      v-zoom='{from:pageName,name:"同意"}'
                      @click="confirmapplicationbinding"
                      >同意</el-button
                    >
                    <el-button
                      size="mini"
                      type="primary"
                      style="width: 60px"
                      v-zoom='{from:pageName,name:"拒绝"}'
                      plain
                      >拒绝</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
            <img src="../../assets/images/next.png" class="next-icon" />
            <el-card class="box-card card-three">
              <div class="content-box">
                <el-form ref="form" :model="form" label-width="85px">
                  <div class="content-head">
                    <div class="float-left">
                      <img
                        src="../../assets/images/store.png"
                        class="head-icon"
                      />
                      <span :style="{ color: changeColor }">店铺B(主)</span>
                    </div>
                    <div class="float-right">
                      <img
                        src="../../assets/images/showList.png"
                        class="show-icon"
                      />
                    </div>
                    <span
                      class="background"
                      :style="{ background: changeColor }"
                    ></span>
                  </div>
                  <div class="content-center">
                    <span>卖家信息</span>
                  </div>
                  <div class="content-detail">
                    <div class="item">
                      <el-form-item label="当前客户：">
                        <el-select
                          v-model="value"
                          placeholder="请选择"
                          size="mini"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <!-- <div class="select-box">
                      <span class="select-item">店铺B(主)</span>
                      <img src="../../assets/images/select1.png" class="select-icon" />
                      </div>-->
                    </div>
                    <div class="item">
                      <span>当前版本：</span>
                      <!-- <div class="select-box">
                      <span class="select-item">店铺B(主)</span>
                      <img src="../../assets/images/select1.png" class="select-icon" />
                      </div>-->
                    </div>
                    <div class="item">
                      <span>软件到期：</span>
                      <!-- <div class="select-box">
                      <span class="select-item">店铺B(主)</span>
                      <img src="../../assets/images/select1.png" class="select-icon" />
                      </div>-->
                    </div>
                    <!-- <div class="absolute-item">
                    <span
                      class="item"
                      :style="{'background': changeColor}"
                      style="color: #fff;"
                    >店铺B(主)</span>
                    <span class="item">店铺A(子)</span>
                    </div>-->
                  </div>
                </el-form>
              </div>
            </el-card>
          </div>
          <div class="step-num-box"></div>
        </div>
        <div class="el-steps-one">
          <el-steps :active="1" finish-status="success">
            <el-step title="发出绑定申请"></el-step>
            <el-step title="同意绑定申请"></el-step>
            <el-step title="绑定成功"></el-step>
          </el-steps>
        </div>
      </div>
    </div>

    <!-- 发送成功提示 -->
    <!-- <el-dialog
      :visible.sync="successDialog"
      title="提示"
      width="400px"
      append-to-body
      custom-class="send-con-dialog"
    >
      <div class="success-tip">
        <img src="@/assets/images/tip_success.png" />
        <span>请确定当前店铺授权给</span><span></span>【{{}}】管理</span>
      </div>
      <div class="btn-group">
        <el-button @click="handleViewRecord">查看记录</el-button>
        <el-button type="primary" @click="handleConSending">继续发送</el-button>
      </div>
    </el-dialog> -->

    <el-dialog
      title="身份验证"
      :visible.sync="exchangeMsg"
      width="35%"
      style="min-width: 1130px"
      :before-close="colseCompleteBind"
      center
    >
      <template slot="title">
        <span>身份验证</span>
      </template>
      <div class="exchange-msg-wrapper">
        <div class="tips-head">
          <img src="../../assets/images/tishi.png" class="tips-icon" />
          <span>为了保护您的财产安全，短信转移需要手机验证</span>
        </div>
        <div class="checked-box">
          <div class="item">
            <span>
              手机号：
              <el-input
                v-model="phoneNum"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 120px;
                "
                size="small"
              ></el-input>
            </span>
            <span></span>
          </div>
          <div class="item">
            <span>验证码：</span>
            <el-input
              v-model="transferVerifyIdentityParams.inputCode"
              style="display: inline-block; vertical-align: middle; width: 95px"
              size="small"
            ></el-input>
            <el-button
              type="text"
              style="margin-left: 10px"
              @click="getCaptcha"
              v-zoom='{from:pageName,name:buttonContent}'
              ref="mesaageButton"
              >{{ buttonContent }}</el-button
            >
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="completeBind">确定</el-button>
        <el-button @click="colseCompleteBind">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  findShopBind,
  applyId,
  applyApplicationBinding,
  cancelBind,
  accessBind,
  checkCode,
} from "@/api/backstage/storeBinding";
import { querySellerSetting, checkCodeSet } from "@/api/backstage/a_setting"; //判断是否有绑定手机号
import { getSellerInfo ,getShopInfo} from "@/api/sellerController"; //获取当前客户信息
import { mapState, mapMutations } from "vuex";
export default {
  name: "store-bind",
  data() {
    return {
      shopInfo: {}, // 店铺信息
      pageName:"后台管理-多店铺绑定",
      bindStatus: "",
      form: {},
      options: [
        {
          value: "选项1",
          label: "店铺B（主）",
        },
        {
          value: "选项2",
          label: "店铺（A）子",
        },
      ],
      value: "",
      statuse: "", //主店和子店的状态来判断显示和隐藏
      hostshop: "", //授权主店铺
      phoneNum: "",
      //changeColor: '#2062E7',
      exchangeMsg: false,
      buttonContent: "发送验证码",
      totalTime: 60,
      /*
       * 模拟数据
       * */
      phoneBinded: false, //手机号是否已绑定
      successDialog: false, //确认申请绑定弹框
      wangwangNum: "",
      rawHtml: '<span style="color:red">利用vue添加了插入一个span 元素</span>',
      shopName: "",
      hostOrSonFlag: 2,
      statestore: true, //店铺状态
      status: true,
      sellerShopBindingId: "",
      talbeLoading: true,
      transferVerifyIdentityParams: {
        inputCode: "",
      },
      tableList: [],
      clock:"",
      demoData: [
        {
          store: "店铺A(子)",
          state: "等待审核",
          num: "2016-08-31 14:36:46",
        },
      ],
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, '多店铺绑定', '后台管理', '系统设置')
  },
  mounted: function () {
    this.checkPhoneBinded();
    this.findShopBind();
    getSellerInfo().then((res) => {
      if (res.data.code == "0") {
            this.$message.error(res.data.message);
      }
      this.shopName = res.data.shopTitle;
      this.shopInfo.isSimulation = res.data.isSimulation
      //this.phoneNum=res.data.mobile;
    });
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  methods: {
     ...mapMutations({
       editUserInfo: "LOGINUSERINFO",
      getSwitchList:"getSwitchList"
    }),
    //跨组件绑定
    getBindList() {
      getSellerInfo().then((resp) => {
        console.log(resp.data);
        this.editUserInfo(resp && resp.data);
        getShopInfo().then((res) => {
          if (res.code == "1") {
            var switchList = res.data.bindshop;
            if (switchList.length > 0) {
              var sellerNick = resp.data.sellerNick;
              console.log("sellerNick:", sellerNick);
              switchList.forEach((item) => {
                if (item.claimer == sellerNick) {
                  item.shopName = item.hostshop;
                } else {
                  item.shopName = item.claimer;
                }
              });
              this.switchList = switchList;
              this.getSwitchList(this.switchList);
              console.log(111111111,this.$store.state.switchList);
            }
          }
        });
      });
    },
    //获取店铺列表
    findShopBind() {
      findShopBind({})
        .then((res) => {
          if (res.data.code == "0") {
            this.$message.error(res.data.message);
          }
          this.talbeLoading = false;
          if (res.data.role == 2) {
            this.tableList = res.data.bindHostList;
            console.log(this.tableList);
            this.hostOrSonFlag = res.data.role; //标识主店铺还是子店铺
          } else if (res.data.role == 1) {
            this.tableList = res.data.bindChildList;
            this.bindStatus = res.data.bindChildList[0].status;
            this.hostshop = this.tableList[0].hostshop;
            this.statuse = this.tableList[0].status;
            this.sellerShopBindingId = this.tableList[0].id;
            this.hostOrSonFlag = res.data.role; //标识主店铺还是子店铺
            console.log(this.hostOrSonFlag);
            console.log(this.statuse);
          } else {
            this.tableList = [];
            this.hostOrSonFlag = res.data.role; //标识主店铺还是子店铺
          }
        })
        .catch(() => {});
    },
    //拒绝申请
    updateBindingStatushand(status, id) {
      applyId({ id: id })
        .then((res) => {
          if (res.data.code == "0") {
            this.$message.error(res.data.message);
          }else{
            this.findShopBind();
           this.$message.success(res.message);
          }
       
        })
        .catch(() => {});
    },
    //确认申请绑定弹框
    confirmapplicationbinding() {
      this.successDialog = true;
    },
    //申请绑定
    handleBind() {
      if(this.shopInfo.isSimulation){
        this.$message.warning("非法登录不支持操作")
        return
      }else if(this.wangwangNum == ""){
        this.$message.info("请输入账号");
        return;
      }else{
        applyApplicationBinding({
        hostShop: this.wangwangNum,
       }).then((res) => {
         this.exchangeMsg = true;
       });
      }
      // .catch((err) => {
      //   this.$message.error("目标店铺没有订购云短信服务！");
      // });
    },
    //判断是否有绑定手机号
    checkPhoneBinded() {
      querySellerSetting({
        Accept: "*/*",
      }).then((res) => {
        console.log(res);
        if (res.data.sellerVO.mobile != "") {
          this.phoneBinded = true;
        }
      });
    },
    clearTime() //清除定时器
{
  clearInterval(this.clock);
},
    //申请绑定完成后发送验证码
    getCaptcha: function () {
      if (!this.phoneNum) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      this.submitting = !0;
      checkCode({
        bindingPhone: this.phoneNum,
        hostShop: this.wangwangNum,
      }).then((res) => {
        console.log(res);
        if (res.code!=1) {
          this.phoneNum="";
          this.$message.error("输入手机号错误");
          return;
        }else if (res.code==1) {
          let self = this;
        this.$refs.mesaageButton.disabled = true;
        this.clock = window.setInterval(() => {
          self.totalTime--;
          self.buttonContent = self.totalTime + "s后重新发送";
          if (this.totalTime == 0) {
            window.clearInterval(this.clock);
            this.buttonContent = "发送验证码";
            self.$refs.mesaageButton.disabled = false;
            self.totalTime = 60;
          }
        }, 1000);
        }
        
      });

      //  checkCode({
      //   bindingPhone: this.phoneNum,
      //   hostShop: this.wangwangNum,
      // })
      //   .then((res) => {
      //     console.log(res);
      //     console.log(111);
      //   })
      //   .catch((res) => {
      //     console.log(222);
      //     // this.$message.error(res.message);
      //   });
    },
    //取消申请
    colseCompleteBind(){
     this.exchangeMsg = false;
     this.phoneNum="";
          this.transferVerifyIdentityParams.inputCode="";
          // this.totalTime=60;
          console.log(this.totalTime);
          this.clearTime();
          this.totalTime=60;
          this.buttonContent = "发送验证码";
          this.$message.warning("已取消申请")
    },
    //身份验证
    completeBind() {
      if (this.transferVerifyIdentityParams.inputCode=="") {
        this.$message.warning("请输入验证码");
        return;
      }
      // confirmBindingShop({
      //     // vcode:this.transferVerifyIdentityParams.inputCode,
      //     hostNick:this.wangwangNum
      // }).then((res)=>{
      //     if(res.code == 200){
      //       this.$message.success(res.message);
      //       this.exchangeMsg = false
      //       this.findShopBind();
      //     }
      // })
      console.log(this.wangwangNum);
      let dto={
         hostShop: this.wangwangNum,
        vCode:this.transferVerifyIdentityParams.inputCode,
      }
      console.log(this.wangwangNum);
      console.log(this.transferVerifyIdentityParams.inputCode);
      console.log(dto);
      applyApplicationBinding(
       dto
      )
        .then((res) => {
          this.phoneNum="";
          this.transferVerifyIdentityParams.inputCode="";
          this.clearTime();
          // this.totalTime=60;
          this.buttonContent = "发送验证码";
          this.exchangeMsg = false;
          // console.log(res);
          if (res.code==1) {
            this.$message({
        dangerouslyUseHTMLString: true,
        type: 'success',
        message: `<span>发起授权成功,请在【</span>${this.wangwangNum}<span>】店铺中完成确认审核</span>`,
      })
          }else {
            this.$message.error(res.message)
          }
        
          this.findShopBind();
        })
        .catch(() => {
          this.$message.error("查到该店铺名称，可能未订购软件或账号错误");
          this.exchangeMsg = true;
        });
    },
    //取消绑定
    updateBindingStatushandOne(status, id) {
      console.log(id);
      this.wangwangNum="";
      cancelBind({ id: id })
        .then((res) => {
          if (res.data.code == "0") {
            this.$message.error(res.data.message);
          }else{
            this.findShopBind();
            this.getBindList();
            this.$message.success(res.message);
          }
        })
        .catch(() => {});
    },
    //同意
    updateBindingaccess(status, id) {
      let str;
      status == 1
        ? (str = "此操作将同意绑定, 是否继续?")
        : (str = "此操作将取消绑定, 是否继续?");
      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass:"iconfont iconicon-jinggao1",
      })
        .then(() => {
          accessBind({
            id: id,
          }).then((res) => {
            if (res.data.code == "0") {
               this.$message.error(res.data.message);
             }else{
              this.findShopBind();
              this.getBindList();
              this.$message.success(res.message);
             }
          });
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  height: 32px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  line-height: 32px;
  padding-left: 12px;
  margin-top: 30px;
  .title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }
  .tips {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
}
.section-right-content-box {
  min-width: 1046px;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 15px 28px 30px 28px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 20px;
  .friend {
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    color: rgba(46, 52, 88, 1);
    opacity: 1;
    padding-bottom: 10px;
    border-bottom: 1px solid #f6f6f6;
  }
  .head-box {
    background: #fafafa;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px;
    overflow: hidden;
    font-size: 14px;
    color: #333333;
    margin-top: 20px;
    .head-icon {
      float: left;
      margin-right: 8px;
    }
    .head-content {
      float: left;
      width: 64%;
      line-height: 20px;

      .block {
        display: block;
      }
    }
  }
  .store-box {
    margin-top: 20px;
    margin-bottom: 20px;
    .icon-box {
      width: 56px;
      height: 56px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      border: 1px solid #ebebeb;
      text-align: center;
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
      font-size: 14px;
      .icon {
        margin: 15px auto 15px auto;
      }
    }
  }
  .binding-box {
    margin-left: 26px;
    font-size: 14px;
    text-align: left;
    .binding-content {
      .Application {
        color: #11b949;
        margin-right: 20px;
      }
      .content-right {
        display: inline-block;
        vertical-align: middle;
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 300px;
          margin-right: 40px;
        }
        .button {
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          border-radius: 3px;
        }
      }
      .tips {
        display: block;
        margin-left: 55px;
        margin-top: 15px;
        color: #ff7600;
        .tips-text {
          text-decoration: underline;
          margin-left: 3px;
          cursor: pointer;
        }
      }
    }
    .binding-foot {
      width: 640px;
      background-color: rgba(255, 118, 0, 0.1);
      color: #ff7600;
      text-align: left;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 5px;
      margin-top: 15px;
      margin-left: -20px;
      .foot-icon {
        display: inline-block;
        vertical-align: middle;
        margin: 0 5px;
      }
    }
  }
  .step-box {
    margin-top: 38px;
    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      margin-bottom: 20px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
    }
    .step-detail-box {
      margin: 0 10px 25px 10px;
      .step-tips {
        font-size: 14px;
        margin-bottom: 20px;
        .icon {
          display: inline-block;
          vertical-align: middle;
        }
      }
      .step-card-box {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        font-size: 14px;

        .next-icon {
          margin: 0 2%;
        }

        .card-one {
          // padding: 10px 0;
          // width: 320px;
          margin: 0 auto;
          .button {
            width: 70px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            display: inline-block;
            vertical-align: middle;
            -webkit-border-radius: 2px;
            -moz-border-radius: 2px;
            border-radius: 2px;
            margin: 10px;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
          }
        }

        .card-three {
          margin: 0 auto;
          .content-box {
            .content-head {
              position: relative;
              // width: 241px;
              height: 40px;
              overflow: hidden;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              padding: 0 17px;
              .float-left {
                float: left;
                margin-top: 8px;
                .head-icon {
                  display: inline-block;
                  vertical-align: middle;
                  margin-right: 7px;
                }
              }
              .float-right {
                float: right;
                margin-top: 10px;
              }
              .background {
                position: absolute;
                opacity: 0.1;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
              }
            }
            .content-center {
              height: 33px;
              // width: 241px;
              line-height: 33px;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              padding: 0 15px;
              border: 1px solid #f2f2f2;
              color: #666666;
            }
            .content-detail {
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              padding: 15px;
              position: relative;
              border: 1px solid #f2f2f2;
              .item {
                color: #666666;
                margin-bottom: 5px;
                .select-box {
                  display: inline-block;
                  vertical-align: middle;
                  width: 100px;
                  height: 25px;
                  line-height: 25px;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  padding: 0 10px;
                  border: 1px solid #d1d2d9;
                  color: #666666;
                  overflow: hidden;
                  -webkit-border-radius: 2px;
                  -moz-border-radius: 2px;
                  border-radius: 3px;
                  .select-item {
                    float: left;
                  }
                  .select-icon {
                    float: right;
                    margin-top: 7px;
                  }
                }
              }
              .absolute-item {
                position: absolute;
                width: 100px;
                border: 1px solid #e6e6e6;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                border-radius: 4px;
                color: #999999;
                right: 15px;
                top: 45px;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                padding: 10px 0;
                background-color: #fff;
                .item {
                  display: block;
                  padding: 5px 10px;
                }
              }
            }
          }
        }
      }
    }
    .el-steps-one {
      margin: 50px 12%;
    }
  }
  .state_tabel {
    .b1 {
      height: 32px;
      color: #ffffff;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .b2 {
      height: 32px;
      color: #666666;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      margin-top: 10px;
      margin-bottom: 20px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
    }
  }
}
/* 身份验证弹窗 */
.exchange-msg-wrapper {
  .tips-head {
    text-align: left;
    background-color: rgba(255, 118, 0, 0.1);
    color: #ff7600;
    box-sizing: border-box;
    padding: 5px 10px;
    font-size: 14px;
    .tips-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .checked-box {
    width: 300px;
    margin: 30px auto 30px auto;
    text-align: left;
    .item {
      margin-bottom: 8px;
    }
  }
}
</style>
